import { toDisplayString as _toDisplayString, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7da99702")

_pushScopeId("data-v-7da99702")
const _hoisted_1 = { class: "pl-2" }
const _hoisted_2 = { class: "mx-1 text-sm overflow-hidden" }
const _hoisted_3 = { class: "w-32 overflow-hidden relative" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa_icon = _resolveComponent("fa-icon")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("p", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createVNode("div", _hoisted_3, [
      _withDirectives(_createVNode("input", {
        type: "text",
        class: "input overflow-hidden",
        placeholder: "DD-MM-AAAA",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.value = $event)),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selected && _ctx.selected(...args))),
        readonly: _ctx.readonly
      }, null, 40, ["readonly"]), [
        [_vModelText, _ctx.value]
      ]),
      (_ctx.value)
        ? (_openBlock(), _createBlock("div", {
            key: 0,
            class: "\n        absolute\n        right-2\n        top-2\n        bottom-0\n        flex\n        items-center\n        -mt-2\n        cursor-pointer\n        text-gray-500\n      ",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.unselect && _ctx.unselect(...args)))
          }, [
            _createVNode(_component_fa_icon, { icon: ['fas', 'times'] })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
})